import AgendamentoApi from '@/Apis/Agendamento/Services/AgendamentoApi'
import EventBus from '@/plugins/EventBus'
import { Convenio } from '@/types/_'
import Vue from 'vue'
import { RequestOptionsProps } from '../types'
import useLoading from '../useLoading'
import { UseConveniosState } from './types'

const useConvenios = (() => {
  const state = Vue.observable<UseConveniosState>({
    fetchedConveniosByCurrentUser: false,
    conveniosByCurrentUser: [],
    conveniosByHospitalId: [],
    lastHospitalIdLoaded: '',
  })

  const { closeLoading, showLoading } = useLoading()

  function setConveniosByCurrentUser(data: Convenio[]) {
    state.conveniosByCurrentUser = data
  }

  function setConveniosByHospitalId(data: Convenio[]) {
    state.conveniosByHospitalId = data
  }

  async function loadConveniosByCurrentUser({
    showLoading: shouldShowLoading = true,
    forceRefresh = false,
    showToastError = true,
  }: RequestOptionsProps = {}) {
    if (state.fetchedConveniosByCurrentUser && !forceRefresh) {
      return { success: true, data: state.conveniosByCurrentUser }
    }
    if (shouldShowLoading) showLoading()
    const response = await AgendamentoApi.getAllConveniosByUsuarioHospitalLogado()
    if (response.success) {
      setConveniosByCurrentUser(response.data)
      state.fetchedConveniosByCurrentUser = true
    } else if (showToastError) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Ocorreu um erro na requisição.',
        icon: 'warning',
        color: '#C62828',
      })
    }
    closeLoading()
    return response
  }

  async function loadConveniosByHospitalId({
    showLoading: shouldShowLoading = false,
    showToastError = false,
    params,
  }: RequestOptionsProps = {}) {
    const { hospitalId } = params
    if (state.lastHospitalIdLoaded === hospitalId) {
      return { success: true, data: state.conveniosByHospitalId }
    }
    if (shouldShowLoading) showLoading()
    const response = await AgendamentoApi.getAllConvenio(hospitalId)
    if (response.success) {
      setConveniosByHospitalId(response.data)
      state.lastHospitalIdLoaded = hospitalId
    } else if (showToastError) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Ocorreu um erro na requisição.',
        icon: 'warning',
        color: '#C62828',
      })
    }
    closeLoading()
    return response
  }

  return {
    get conveniosByCurrentUser(): Convenio[] {
      return state.conveniosByCurrentUser
    },
    get conveniosByHospitalId(): Convenio[] {
      return state.conveniosByHospitalId
    },
    loadConveniosByHospitalId,
    loadConveniosByCurrentUser,
    setConveniosByCurrentUser,
  }
})()

export default useConvenios
